module.exports = __webpack_public_path__ + "static/media/bg_login.2e1c9286.jpg";